import { WidgetRuntime } from '../runtime'
import { Event } from './event'
import { EventContext } from './event-context'

export function track(runtime: WidgetRuntime) {
  return async (events: Event[], context: EventContext) => {
    const time = new Date().getTime()
    for (const e of events) {
      if (e.widget) {
        const saved = runtime.storages.loadFor(e.widget.id, e.type) || {
          time,
          value: 0,
        }
        saved.time = time
        saved.value += 1
        runtime.storages.saveFor(e.widget.id, e.type, saved)
      }
    }
  }
}
